exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mini-navigation {\n  display: block; }\n  mini-navigation .miniNavigation {\n    margin-top: 1rem; }\n    mini-navigation .miniNavigation span {\n      font-size: 10px; }\n    mini-navigation .miniNavigation .spanNav {\n      margin: 0 .2rem;\n      font-size: 10px;\n      cursor: pointer;\n      color: #000; }\n", ""]);

// exports
